import { createContext, useContext, useState, useCallback } from "react";
import { UI } from "../data/content";

const LanguageContext = createContext(null);
const STORAGE_KEY = "medprime_lang";

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored === "en" || stored === "es" ? stored : null;
  });

  const setLang = useCallback((l) => {
    localStorage.setItem(STORAGE_KEY, l);
    setLangState(l);
    document.documentElement.lang = l;
  }, []);

  const resetLang = useCallback(() => {
    localStorage.removeItem(STORAGE_KEY);
    setLangState(null);
  }, []);

  const active = lang || "es";

  return (
    <LanguageContext.Provider
      value={{ lang: active, chosen: !!lang, setLang, resetLang, t: UI[active] }}
    >
      {children}
    </LanguageContext.Provider>
  );
}

export function useLang() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
}
